import React, { useState } from "react";
import { UseApi } from "../../../hooks/use-api";
import { ShipController } from "../../../Services/lib/shipping";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";
import RequestedPage from "./Components/requested";
import Declined from "./Components/declined";
import Approved from "./Components/approved";
import Disclaimer from "../../Disclaimer";
import Shipped from "./Components/shipped";
import { useUser } from "../../../context";
import nft_product from "../../../i11/Nft_Product";

export const statuses_ = {
	REDEEM_REQUESTED: { title: "RECEIVED" },
	REDEEM_RECEIVED: { title: "RECEIVED" },
	REDEEM_DECLINED: { title: "DECLINE" },
	REDEEM_APPROVED: { title: "APPROVE" },
	REDEEM_SHIPPED: { title: "SHIP" },
};

export const statuses__ = {
	REDEEM_REQUESTED: "REQUESTED",
	REDEEM_RECEIVED: "RECEIVED",
	REDEEM_DECLINED: "DECLINED",
	REDEEM_APPROVED: "APPROVED",
	REDEEM_SHIPPED: "SHIPPED",
};

const RedeemInfo = ({ item, refresh }) => {
	const { locale } = useUser();
	const [body, setBody] = useState({
		nftId: item._id,
		status: item.redeemStatus,
		note: "",
	});

	const [{ isLoading }, update] = UseApi({
		service: ShipController,
	});

	const update_ = async () => {
		if (item.redeemStatus === "REDEEM_REQUESTED") {
			const res = await update({
				nftId: item._id,
				status: "REDEEM_RECEIVED",
				note: "",
			});
			if (res) {
				refresh();
				ToastEmitter({
					msg: "Successfully updated",
					type: "success",
				});
			}
		} else {
			const res = await update(body);
			if (res) {
				refresh();
				ToastEmitter({
					msg: "Successfully updated",
					type: "success",
				});
			}
		}
	};

	const props = { item, body, setBody, update_, isLoading, refresh };

	const pages = {
		REDEEM_REQUESTED: <RequestedPage {...props} />,
		REDEEM_RECEIVED: <RequestedPage {...props} />,
		REDEEM_DECLINED: <Declined {...props} />,
		REDEEM_APPROVED: <Approved {...props} />,
		REDEEM_SHIPPED: <Shipped {...props} />,
	};

	return item.shipment ? (
		<>{pages[item.redeemStatus]}</>
	) : (
		<div>
			<Disclaimer>{nft_product[locale].normal}</Disclaimer>
		</div>
	);
};

export default RedeemInfo;
